export const DEFAULT_API_URL = process.env.BUILDAUTOMATON_API_URL ?? 'https://api.buildautomaton.com';

/** Default firehose server (Fly.io app) for preview + dev log streaming when not overridden. */
export const DEFAULT_FIREHOSE_URL = 'https://buildautomaton-firehose.fly.dev';
